import { OnboardingWaitlist } from "./OnboardingWaitlist";

export function OnboardingWaitlistContainer() {
  return <OnboardingWaitlist />;
}

export default OnboardingWaitlistContainer;
